import { FC } from "react";
import PartnersBadge from "../PartnersBadge/PartnersBadge";

const MainReview: FC = (): JSX.Element => {
  return (
    <section className="flex flex-col items-center lg:mb-8 my-24 md:my-14 lg:my-24 mx-7 md:mx-14 lg:mx-auto">
      <h2 className="mb-9 text-4xl font-bold text-center md:text-5xl">
        “It was a pleasure doing business with this company”
      </h2>
      <p className="font-serif w-auto lg:w-[46rem] mb-16 text-xl  text-center font-normal xl:text-2xl">
        “All parties were satisfied. We would not hesitate to do business with this company again.”
      </p>
      <PartnersBadge />
    </section>
  );
};

export default MainReview;
